export default "__VITE_ASSET__04f4b8c9__"